module.exports = __webpack_public_path__ + "static/nomoredreams-97eab163257553801496aa7f88cbb03e.jpg";